export enum ReferrerAccountType {
  Individual = "individual",
  App = "app",
  Agency = "agency",
}
